window.yshomyLocalization = window.yshomyLocalization || {};
window.yshomyLocalization.preferenceKey = 'yshomy:country-preference';
window.yshomyLocalization.rememberCountryPreference = function (country) {
    if (!country) return;

    try {
        localStorage.setItem(window.yshomyLocalization.preferenceKey, country);
    } catch (error) {
        // Storage can be unavailable in strict privacy modes. Shopify's
        // localization cookie still preserves the submitted selection.
    }
};

function yshomyPreferredCountry() {
    try {
        return localStorage.getItem(window.yshomyLocalization.preferenceKey);
    } catch {
        return null;
    }
}

if (typeof localizationForm === 'undefined') {

    class LocalizationForm extends HTMLElement {
        constructor() {
            super();
            this.elements = {
                localeInput: this.querySelector('input[name="locale_code"]'),
                countryInput: this.querySelector('input[name="country_code"]'),
                button: this.querySelector('button'),
                panel: this.querySelector('ul'),
            };
            this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
        }

        // Legacy combined selector support. The YSHomy header uses the separate
        // language and country controls defined below.
        onItemClick(event) {
            event.preventDefault();
            const locale = event.currentTarget.dataset.value;
            const country = event.currentTarget.dataset.country;
            if (this.elements.localeInput && locale) {
                this.elements.localeInput.value = locale;
            }
            if (this.elements.countryInput && country) {
                this.elements.countryInput.value = country;
                window.yshomyLocalization.rememberCountryPreference(country);
            }
            this.querySelector('form')?.submit();
        }

        openSelector() {
            this.elements.button.focus();
            this.elements.panel.toggleAttribute('hidden');
            this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
        }

        closeSelector(event) {
            const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
            if (event.relatedTarget === null || shouldClose) {
                this.elements.button.setAttribute('aria-expanded', 'false');
                this.elements.panel.setAttribute('hidden', true);
            }
        }

        onBodyClickEvent(event){
            if ((!this.contains(event.target)) && ($(event.target).closest('[localization-form__select]').length === 0)){
                this.closeSelector(event);
            }
        }
    }

    customElements.define('localization-form', LocalizationForm);

    var localizationForm = LocalizationForm;
}

if (!customElements.get('yshomy-localization-selector')) {
    class YshomyLocalizationSelector extends HTMLElement {
        connectedCallback() {
            if (this.dataset.initialized === 'true') return;

            this.dataset.initialized = 'true';
            this.onChange = this.onChange.bind(this);
            this.addEventListener('change', this.onChange);
        }

        disconnectedCallback() {
            clearTimeout(this.submitTimer);
            this.removeEventListener('change', this.onChange);
            delete this.dataset.initialized;
        }

        onChange(event) {
            const select = event.target.closest('[data-yshomy-localization-select]');
            if (!select || !this.contains(select)) return;

            if (select.name === 'country_code') {
                window.yshomyLocalization.rememberCountryPreference(select.value);
            }

            const picker = this.querySelector('select[name="country_code"]');
            if (select.name === 'locale_code') {
                const preference = yshomyPreferredCountry();
                if (picker && Array.from(picker.options).some(option => option.value === preference)) {
                    select.form.elements.country_code.value = preference;
                }
            } else if (select.name === 'country_code') {
                const language = this.querySelector('select[name="locale_code"]');
                if (language) select.form.elements.locale_code.value = language.value;
            }
            window.yshomyManualLocalizationStarted = true;
            clearTimeout(this.submitTimer);
            this.submitTimer = setTimeout(() => select.form?.submit(), 150);
        }
    }

    customElements.define('yshomy-localization-selector', YshomyLocalizationSelector);
}

/*
 * Shopify normally resolves a first-time visitor's market from their IP.
 * Returning visitors can keep an older localization cookie, though, so a VPN
 * or network change can leave the storefront on USD. This same-origin check
 * asks Shopify for the request's detected country and corrects the market when
 * needed. A country chosen by the visitor always takes precedence.
 */
if (!window.yshomyIpCountrySyncStarted) {
    window.yshomyIpCountrySyncStarted = true;

    async function syncYshomyCountryFromIp() {
        if (window.Shopify?.designMode) return;
        if (/bot|crawl|spider|slurp|bingpreview|googleother/i.test(navigator.userAgent)) return;
        if (new URLSearchParams(window.location.search).has('country')) return;

        const countrySelect = document.querySelector(
            '[data-yshomy-localization-select][name="country_code"]'
        );
        if (!countrySelect?.form || window.yshomyManualLocalizationStarted) return;
        const preferred = yshomyPreferredCountry();
        if (preferred) {
            if (preferred !== window.Shopify?.country && Array.from(countrySelect.options).some(option => option.value === preferred)) {
                const key = 'yshomy:restore:' + preferred + ':' + window.Shopify?.country;
                try {
                    if (Date.now() - Number(sessionStorage.getItem(key)) < 300000) return;
                    sessionStorage.setItem(key, String(Date.now()));
                } catch { return; }
                countrySelect.value = preferred;
                countrySelect.form.submit();
            }
            return;
        }

        try {
            const response = await fetch('/browsing_context_suggestions.json', {
                cache: 'no-store',
                credentials: 'same-origin',
                headers: { Accept: 'application/json' }
            });
            if (!response.ok) return;

            const payload = await response.json();
            const detectedCountry = payload?.detected_values?.country?.handle?.toUpperCase();
            const currentCountry = countrySelect.value?.toUpperCase();

            if (window.yshomyManualLocalizationStarted || yshomyPreferredCountry()) return;
            if (!/^[A-Z]{2}$/.test(detectedCountry || '')) return;
            if (!currentCountry || detectedCountry === currentCountry) return;

            const isAvailable = Array.from(countrySelect.options).some(
                (option) => option.value.toUpperCase() === detectedCountry
            );
            if (!isAvailable) return;

            const attemptKey = `yshomy:ip-country-attempt:${currentCountry}:${detectedCountry}`;
            try {
                if (sessionStorage.getItem(attemptKey)) return;
                sessionStorage.setItem(attemptKey, '1');
            } catch (error) {
                // A failed or unavailable session store should not prevent the
                // one safe localization submission below.
            }

            countrySelect.value = detectedCountry;
            countrySelect.form.submit();
        } catch (error) {
            // Fail open: keep the current Shopify market and the manual selector.
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', syncYshomyCountryFromIp, { once: true });
    } else {
        syncYshomyCountryFromIp();
    }
}
